import axios from 'axios';

import { throughPromiseCache } from './cacheService';

const ROOT = '/iso-3166-2';

const GeoApi = {
  fetchRegions(countryId) {
    return throughPromiseCache({ key: 'GeoApi.fetchRegions', countryId }, function() {
      return axios.get(`${ROOT}/${countryId}.json`);
    });
  }
};

export default GeoApi;
